import React, { useState } from 'react';
import {
  Box, Link, Text, Tooltip,
} from '@chakra-ui/react';
import { NIL } from 'uuid';
import useContact from '../../hooks/useContact';
import { CustomerStaffMember } from '../../models/contactInfo';

interface Props {
  customerId: string;
  staffId?: string;
  name: string;
  href: string;
}

// item 1461 (Chad: "a hover for the staff team in the sales bible that shows their email and
// phone and leave the click to open new tab and deep link to the CRM") — the CUSTOMER STAFF / PM
// cell: hover = the person's role · phone · email off the customer's CRM roster (fetched lazily on
// first hover, cached per customer by react-query); click = the same new-tab deep link as before.
const StaffHoverLink: React.FC<Props> = ({
  customerId, staffId, name, href,
}) => {
  const [armed, setArmed] = useState(false);
  const { data: customer, status } = useContact({ id: armed ? customerId : NIL });
  const roster: CustomerStaffMember[] = armed ? ((customer?.staff ?? []) as CustomerStaffMember[]) : [];
  const person = roster.find((s) => (!!staffId && s.id === staffId))
    ?? roster.find((s) => s.name?.trim().toLowerCase() === name.trim().toLowerCase());

  let body: React.ReactNode;
  if (!armed || status === 'loading') {
    body = <Text fontSize="xs" opacity={0.7}>Loading contact…</Text>;
  } else if (!person) {
    body = <Text fontSize="xs" opacity={0.7}>Not on this customer&apos;s staff roster — click to open the CRM.</Text>;
  } else {
    body = (
      <Box fontSize="xs" lineHeight="tall">
        <Text fontWeight="semibold">
          {person.name}
          {person.role ? ` · ${person.role}` : ''}
        </Text>
        <Text>{person.phone || 'No phone on file'}</Text>
        <Text>{person.email || 'No email on file'}</Text>
        <Text opacity={0.6} mt={1}>Click to open in the CRM</Text>
      </Box>
    );
  }

  return (
    <Tooltip label={body} hasArrow placement="top" openDelay={250} bg="gray.900" color="whiteAlpha.900" borderRadius="md" p={3}>
      <Link
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title="Open this contact in the CRM"
        _hover={{ textDecoration: 'underline' }}
        onMouseEnter={() => setArmed(true)}
        onFocus={() => setArmed(true)}
      >
        {name}
      </Link>
    </Tooltip>
  );
};

StaffHoverLink.defaultProps = {
  staffId: undefined,
};

export default StaffHoverLink;
